import {transform, isEqual} from 'helpers';
import {AnyObject} from 'types';

export function objectDifference(a: AnyObject, b: AnyObject) {
  return transform(a, (result: AnyObject, value, key) => {
    if (!isEqual(value, b[key])) {
      result[key] = value;
    }
  });
}
